import React, {Component} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import {
	changeNumberFormat,
	deepCopyObject,
	isSularSaglikHizmetleri,
	showAxiosError,
	turkishToLower
} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Alert from 'react-s-alert';
import '../../local_node_modules/react-select/dist/react-select.css';
import 'react-datetime/css/react-datetime.css';
import 'moment/locale/tr';
import ReactLoading from "react-loading";
import {filterOptions} from "../../helper/invoiceHelper";
import Select from "../../local_node_modules/react-select";
import axios from "axios";
import {isValidERPOutboxPyld, isValidInboxLine} from "../../common/componentValidation";
import {UncontrolledTooltip} from "reactstrap";
import CariModalWs from "./CariModalWs";
import ERPLineModalWs from "./ERPLineModalWs";
import {wsSend} from "./erpHelper";
import ReactLoadingTop from "../../components/ReactLoadingTop";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
import CreateGmkodModal from "./CreateGmkodModal";
import {FisType} from "../../helper/enums";

class SendToConnectorModalWs extends Component {

	constructor(props) {
		super(props);
		this.state ={
			selectedList:[],
			inboxList:[],
			randomColorList:[],
			year:null,
			index:0,
			realIndex:0,
			error:{},
			cariOptions:[],
			cariLoading:false,
			fisNumber:0,
			fisBilList: [],
			yevmiyeList: [],
			selectedFisIndex: null,
			selectedYevmiye: [],
			mediaModal: false,
			erpHesapPlani: [],
			erpHesapPlaniData: [],
			hesapSearchIsManual: true,
			saveLoadingFisBil: false,
			saveLoadingYevmiye: false,
			loadingHtml: false,
			hesapPlaniLoading: false,
			nullGmKod: false,
			isStockAccounting: this.props.currentUser.isStockAccounting,
			createGmkodModal: false,
			gmKodModalIndex: null
		};
		this.onCancel     	= this.onCancel.bind(this);
		this.onChange    	= this.onChange.bind(this);
		this.createCari  	= this.createCari.bind(this);
		this.onCariChange   = this.onCariChange.bind(this);
		this.getRandomColor = this.getRandomColor.bind(this);
		this.validateMessage= this.validateMessage.bind(this);
		this.validateClass  = this.validateClass.bind(this);
		this.setCari  		= this.setCari.bind(this);
		this.setLine  		= this.setLine.bind(this);
		this.cancelFisModal = this.cancelFisModal.bind(this);
		this.onChangeYevmiye = this.onChangeYevmiye.bind(this);
		this.onChangeHesapKodu = this.onChangeHesapKodu.bind(this);
		this.downloadMedia = this.downloadMedia.bind(this);
		this.setMediaModalClose = this.setMediaModalClose.bind(this);
		this.onChangeGetErpHesapKodu = this.onChangeGetErpHesapKodu.bind(this);
		this.arrowRenderer = this.arrowRenderer.bind(this);
		this.confirmFis = this.confirmFis.bind(this);
		this.checkNullGmKod = this.checkNullGmKod.bind(this);
		this.onChangeStockAccounting = this.onChangeStockAccounting.bind(this);
		this.createGmkod = this.createGmkod.bind(this);
		this.closeGmKodModal = this.closeGmKodModal.bind(this);
	}

	componentDidMount = async()=> {
		let self = this;
		self.listenWebSocket(this.props.connectionInfo.ownerIp);
		await self.delay(1000);
		let documentType = this.props.documentType ? this.props.documentType : "invoice";
		if (documentType !== "fisOutbox" && documentType !== "fisInbox" && documentType !== "archiveAccountingReceipt") {
			let params = {
				url: documentType === 'invoice' ? `/inbox/getErpLineList` : documentType === "invoiceOutbox" ? `/outbox/getErpLineList` : documentType === "earchiveInvoice" ? `/eArchive/getErpLineList` : `/despatchInbox/getErpLineList`,
				method: "post",
				data: {
					recordIdList: self.props.recordIdList,
					year: this.props.year,
                    month: this.props.month,
					recordType: this.props.recordType
				}
			};

			try {
				self.setState({loading: true});
				const response = await request(params);
				let {inboxList, cariList, stockList} = response.data;
				let cariListSql = cariList.result;
				let stockCodeList = [];
				let stockNameList = [];

				for (let i = 0; i < stockList.length; i++) {
					if (stockList[i].itemCode)
						stockCodeList[stockList[i].itemCode] = stockList[i];

					if (stockList[i].edmItemName)
						stockNameList[stockList[i].edmItemName] = stockList[i];
				}
				self.send(cariListSql, "READ_ALL_CUSTOMER");

				self.setState({inboxList, stockCodeList, stockNameList});

			} catch (error) {
				showAxiosError(error);
				self.props.toggleModal(false, false);
			}
		} else if (documentType === "fisOutbox" || documentType === "fisInbox" || documentType === "archiveAccountingReceipt") {
			self.setState({loading: true});
			try {

				let params = {
					url: "/hesapPlani/getHesapPlani/"+ null,
					method: "get"
				};
				request(params).then((response) => {
					this.send(response.data, "GET_HESAP_PLANI");
				})

				let paramsMaxFisNo = {
					url: "/connector/getMaxFisNoQuery",
					method: "get"
				}

				request(paramsMaxFisNo).then((response) => {
					self.send(response.data, "GET_MAX_FIS_NO");
				})

			} catch (error) {
				showAxiosError(error);
				self.props.toggleModal(false, false);
			}
		}
	}

	delay = ms => new Promise(res => setTimeout(res, ms));

	listenWebSocket = (ip) =>{
		let self = this;
		ip= ip + "/websocket/chat";
		const ws = new WebSocket(ip);
		self.setState({ws});

		ws.onopen = () => {
			console.log('connected');
			self.setState({isWsConnected:true});
		}

		// listen to data sent from the websocket server
		ws.onmessage = evt => {
			let {queryType,rows,uuid} = JSON.parse(evt.data)
			rows = JSON.parse(rows);
			console.log("gelen veri",rows)

			if(queryType == "READ_ALL_CUSTOMER" && rows != null){
				const{inboxList,stockCodeList,stockNameList} = self.state;
				let cariVknTcknList=[];

				for(let i=0;i<rows.length;i++){
					if(rows[i].vknTckn)
						cariVknTcknList[rows[i].vknTckn] = rows[i];
				}

				for(let i=0;i<inboxList.length;i++){
					if(inboxList[i].vknTckn){
						if (inboxList[i].vknTckn.length === 11 && isSularSaglikHizmetleri(self.props.currentUser.vknTckn)) {
							inboxList[i].cariCode = "120.18";
							inboxList[i].cariReferenceId = "4e8ae950-b4b6-430e-acf8-dfa0de3b80ca";
							inboxList[i].success = true;
							self.setState({manual: true});
						} else if (cariVknTcknList[inboxList[i].vknTckn]) {
							inboxList[i].cariCode = cariVknTcknList[inboxList[i].vknTckn].cariCode;
							inboxList[i].cariReferenceId = cariVknTcknList[inboxList[i].vknTckn].referenceId;
							inboxList[i].vknTckn = cariVknTcknList[inboxList[i].vknTckn].vknTckn;
							inboxList[i].success = true;
						}
					}
					let inboxLineList = inboxList[i].inboxLineList;
					for(let j=0;j<inboxLineList.length;j++){
						let flag = true;
						if(inboxLineList[j].edmItemName){
							if(stockNameList[inboxLineList[j].edmItemName]){
								inboxLineList[j].itemCode=	stockNameList[inboxLineList[j].edmItemName].itemCode;
								inboxLineList[j].itemName=	stockNameList[inboxLineList[j].edmItemName].itemName;
								inboxLineList[j].itemUnit=	stockNameList[inboxLineList[j].edmItemName].itemUnit;
								inboxLineList[j].stockReferenceId=stockNameList[inboxLineList[j].edmItemName].referenceId;
								inboxLineList[j].lineType=stockNameList[inboxLineList[j].edmItemName].lineType;
								inboxLineList[j].success = true;
								flag=false;
							}
						}
						if(flag){
							if(inboxLineList[j].itemCode){
								if(stockCodeList[inboxLineList[j].itemCode]){
									inboxLineList[j].itemName 	=stockCodeList[inboxLineList[j].itemCode].itemName;
									inboxLineList[j].itemUnit 	=stockCodeList[inboxLineList[j].itemCode].itemUnit;
									inboxLineList[j].stockReferenceId=	stockCodeList[inboxLineList[j].itemCode].referenceId;
									inboxLineList[j].edmItemName=stockCodeList[inboxLineList[j].itemCode].edmItemName;
									inboxLineList[j].lineType=stockCodeList[inboxLineList[j].itemCode].lineType;
									inboxLineList[j].success = true;
									flag=false;
								}
							}
						}
					}
					inboxList.inboxLineList = inboxLineList;
					self.setState({inboxList,loading:false});

				}

			}else if(queryType == "READ_INVOICE" && rows != null ) {
				if (rows.length === 0) {
					Alert.success("Ara kriterlerine uygun fatura bulunamadı.", {
						position: 'bottom-right',
						effect: 'stackslide',
						timeout: 4000
					});
				}
				self.setState({outboxList:rows,searching:false,index:0});
			}else if(queryType == "READ_INVOICE_LINE" && rows != null ) {
				const {outboxList} = self.state;
				outboxList.map(outbox=>{
					if(outbox.documentUuid == uuid){
						outbox.trdDocInvoiceLines = rows;
						outbox.status = "processing";
						let referenceIdList = "";
						let invoiceTypeCode = outbox.invoiceTypeCode;
						rows.forEach(invoiceLine=>{
							referenceIdList += invoiceLine.referenceId + "-"
							if(invoiceLine.unit == '' || invoiceLine.unit == null){
								invoiceLine.unit = "C62";
							}
						})
						referenceIdList = referenceIdList.slice(0, -1)
						self.readInvoiceLineChargeSql(referenceIdList,invoiceTypeCode,outbox.documentUuid)

						return outbox;

					}
				})
			}else if(queryType == "READ_INVOICE_LINE_CHARGE" && rows != null ) {
				const {outboxList} = self.state;

				let invoiceIndex  = outboxList.findIndex(x => x.documentUuid ===uuid);
				let invoice = outboxList[invoiceIndex];

				let lines = invoice.trdDocInvoiceLines;
				for(let i = 0;i<lines.length;i++){
					for(let j = 0; j< rows.length; j++){
						if(lines[i].referenceId == rows[j].invoiceLineId){
							let arr = [];
							if(lines[i].trdDocInvoiceLineCharges !=null && lines[i].trdDocInvoiceLineCharges.length>0){
								arr = lines[i].trdDocInvoiceLineCharges;
							}
							arr.push(rows[j]);
							lines[i].trdDocInvoiceLineCharges = arr;
						}
					}
				}
				let result = isValidERPOutboxPyld(invoice, invoiceIndex);
				let valid = result.valid;
				if (valid) {
					self.saveToTemp(invoice,invoiceIndex)
				}else{
					self.setState({error:result.error,confirmBtnDisabled:false});
					Alert.error(result.errorMessage, {
						position: 'bottom-right',
						effect: 'stackslide',
						timeout: 3000
					});
				}

				outboxList[invoiceIndex].trdDocInvoiceLines = lines;
				self.setState({confirmBtnDisabled: true, outboxList});
			}else if(queryType == "READ_CUSTOMER" && rows != null ) {
				let cariList = rows;
				let options = cariList.map(cari => ({
					value: cari.vknTckn,
					label: cari.cariCode + "-" + cari.vknTckn + "-" + cari.formattedName,
					cari: cari
				}));
				options.push({
					value:-1,
					label:"ERP Cari Listesine Ekle"
				})
				self.setState({cariOptions: options,cariLoading:false});
			}else if(queryType == "WRITE_CUSTOMER" && rows != null ) {
				Alert.success("Ara kriterlerine uygun fatura bulunamadı.", {
					position: 'bottom-right',
					effect: 'stackslide',
					timeout: 4000
				});
				self.setCari(rows);
			}else if((queryType == "WRITE_INVOICE" || queryType == "WRITE_DESPATCH" || queryType == "WRITE_SEND_INVOICE") && rows != null){
				let {inboxList} = self.state;
				inboxList = deepCopyObject(inboxList);
				console.log("inboxList",inboxList);
				let inbox;
				let index;
				if (!rows[0].documentId && inboxList.length === 1) {
					inbox = inboxList[0];
				} else {
					index = inboxList.findIndex(x => x.documentId === rows[0].documentId);
					inbox = inboxList[index];
				}

				let referenceId = rows[0].referenceId ? rows[0].referenceId : rows[0].documentId;
				self.updateInboxReferenceId(inbox,referenceId);

				let lineList =inbox.inboxLineList;
				if(lineList.length>0){
					lineList.map((line,index)=>{
						if(line.stockReferenceId == null){
							//TODO alert vericek
						}
						//invLineMapper(inbox,line)

					})
				}
				self.writeInvoiceLineSql(inbox,rows[0]);
			} else if ((queryType == "WRITE_INVOICE_LINE" || queryType == "WRITE_SEND_INVOICE_LINE") && rows != null) {
				console.log('ehehe, kalem başarılı bir şekilde yazdı');
				let {inboxList} = self.state;
				inboxList = deepCopyObject(inboxList);
				let index = inboxList.findIndex(x => x.documentId === rows[0].documentId);
				let inbox = inboxList[index];
				if (rows[0].invoiceLineNo && (rows[0].invoiceLineNo === inbox.inboxLineList.length || this.props.currentUser.vknTckn === "1960733903")) {
					inbox.status = "success";
					inbox.success = true;
					inboxList[index] = inbox;
					self.setState({inboxList, index: this.state.index + 1});
					this.confirm(this.state.index);
				}
			}else if(queryType == "ERROR") {
				if (!["fisOutbox","fisInbox","archiveAccountingReceipt"].includes(this.props.documentType)) {
					let {inboxList} = self.state;
					let index = inboxList.findIndex(x => x.documentId === rows[0].documentId);
					let inbox = inboxList[index < 0 ? 0 : index];
					inbox.status = "error";
					inbox.success = false;
					let error =
						Alert.error("Fatura aktarılamadı.", {
							position: 'bottom-right',
							effect: 'stackslide',
							timeout: 4000
						});
					self.setState({inboxList, index: this.state.index + 1});
					this.confirm(this.state.index);
				}
			}else if (queryType == "GET_MAX_FIS_NO" && rows != null) {
				let fisNumber = rows[0].Column1;
				self.setState({fisNumber: fisNumber})
				this.getFisData(fisNumber);
			}else if (queryType == "GET_HESAP_PLANI" && rows != null) {
				let hesapPlani = rows
				let options = hesapPlani.map(kod => ({
					value: kod.kod,
					label: kod.kod + "-" + kod.aciklama,
					tckimlikno: kod.tckimlikno,
					vergikimlikno: kod.vergikimlikno
				}));
				this.setState({erpHesapPlani: options, erpHesapPlaniData: options, hesapPlaniLoading: false, hesapSearchIsManual: false})
			}else if (queryType === "GET_HESAP_PLANI" && rows == null) {
				this.setState({hesapSearchIsManual: true})
			}else if (queryType === "SAVE_FIS_BILGISI" && rows == null) {
				console.log("Fiş Kaydı Başarılı");
			}else if (queryType === "SAVE_YEVMIYE" && rows == null) {
				console.log("Yevmiye Kaydı Başarılı");
			}
		}

		ws.onclose = () => {
			console.log('disconnected')
			self.listenWebSocket(self.props.connectionInfo.ownerIp)
			this.setState({isWsConnected:false});
		}
	}

	getFisData = (fisNo) => {
		let params;
		let documentType = this.props.documentType;
		params = {
			url: `/connector/getErpFisLineList`,
			method: "post",
			data: {
				recordIdList: this.props.recordIdList,
				year: this.props.year,
				month: this.props.month,
				fisNo: fisNo,
				recordType: this.props.recordType,
				isStockAccounting: this.state.isStockAccounting,
				fisType: documentType === "fisInbox" ? FisType.fisInbox : documentType === "fisOutbox" ? FisType.fisOutbox : FisType.archiveAccountingReceipt,
				accountingReceiptWithDiscount: this.props.connectionInfo.accountingReceiptWithDiscount
			}
		}
		request(params).then((response) => {
			let selectedYevmiye = response.data.yevmiyeResponsePayloadList.filter((f) => {
				return f.fisNo === response.data.fisBilResponsePayloadList[0].fisNo;
			});
			let yevmiyeList = response.data.yevmiyeResponsePayloadList;
			let hesapPlani = this.state.erpHesapPlaniData;

			yevmiyeList.forEach(yevmiye => {
				if (yevmiye.gmKod === "600") {
					let uygunHesapPlani = hesapPlani.find(plani => (plani.tckimlikno === yevmiye.vergiNo) && plani.value.startsWith('600'));

					if (uygunHesapPlani === undefined || uygunHesapPlani === null) {
						uygunHesapPlani = hesapPlani.find(plani => (plani.vergikimlikno === yevmiye.vergiNo) && plani.value.startsWith('600'));
					}

					if (uygunHesapPlani) {
						yevmiye.gmKod = uygunHesapPlani.value;
					}
				}
				if (yevmiye.gmKod === "120") {
					let uygunHesapPlani = hesapPlani.find(plani => (plani.tckimlikno === yevmiye.vergiNo) && plani.value.startsWith('120'));

					if (uygunHesapPlani === undefined || uygunHesapPlani === null) {
						uygunHesapPlani = hesapPlani.find(plani => (plani.vergikimlikno === yevmiye.vergiNo) && plani.value.startsWith('120'));
					}
					if (uygunHesapPlani) {
						yevmiye.gmKod = uygunHesapPlani.value;
					}
				}
				if (yevmiye.gmKod === "320") {
					let uygunHesapPlani = hesapPlani.find(plani => (plani.tckimlikno === yevmiye.vergiNo) && plani.value.startsWith('320'));

					if (uygunHesapPlani === undefined || uygunHesapPlani === null) {
						uygunHesapPlani = hesapPlani.find(plani => (plani.vergikimlikno === yevmiye.vergiNo) && plani.value.startsWith('320'));
					}

					if (uygunHesapPlani) {
						yevmiye.gmKod = uygunHesapPlani.value;
					}
				}
			});

			response.data.fisBilResponsePayloadList[0]["selected"] = true;
			this.setState({
				fisBilList: response.data.fisBilResponsePayloadList,
				yevmiyeList: response.data.yevmiyeResponsePayloadList,
				selectedYevmiye: selectedYevmiye
			});
			this.setState({loading: false})
		}).catch((error) => {
			Alert.error(error.response.data, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
			this.props.toggleModal(false,false);
		});
	}

	cancelFisModal = () => {
		this.setState({fisBilModal: false})
	}

    openGmkodModal(check, index) {
        this.setState({createGmkodModal: true, gmKodModalIndex: index})
    }

    createGmkod(data) {
		let self = this;
		let params = {
			url: "/hesapPlani/getSaveHesplanQuery",
			method: "post",
			data: data
		};
		request(params).then((response) => {
			self.send(response.data, "SAVE_HESPLAN");
		})
		self.closeGmKodModal();
		let newData = {
			value: data.gmkod
		};
		self.onChangeHesapKodu(newData, this.state.gmKodModalIndex);
    }

	updateInboxReferenceId = async(document,referenceId)=>{
		let data = {
			type:this.props.documentType,
			year:document.documentIssueDate?new Date(document.documentIssueDate).getFullYear():new Date().getFullYear(),
			recordId:document.recordId,
			referenceId
		};
		let params = {
			url: `/connector/updateReferenceId`,
			method: "post",
			data:data
		};
		try{
			let {data} = await request(params);
		}catch(error){
			console.log(error)
		}
	}

	send = async(query,queryType,documentUuid) =>{
		const {connectionInfo} = this.props;
		let {ws,isWsConnected} = this.state;
		if ((this.props.documentType === "fisOutbox" || this.props.documentType === "fisInbox" || this.props.documentType === "archiveAccountingReceipt") && (connectionInfo.showAccountingReceipt)) {
			let lastChar = connectionInfo.initialCatalog.charAt(connectionInfo.initialCatalog.length - 1);
			let newInitialCatalog = lastChar === "T" ? connectionInfo.initialCatalog.slice(0, -1) : connectionInfo.initialCatalog;
			connectionInfo.initialCatalog = newInitialCatalog;
		}
		if(!isWsConnected){
			await new Promise(r => setTimeout(r, 1000));
		}
		if (ws.isWsConnected == false) {
			ws.close();
			this.handleWebsocket();

			while (isWsConnected == true) {
				await new Promise(r => setTimeout(r, 1000));
			}
		}
		wsSend(connectionInfo,ws,query,queryType,documentUuid)
	}

	onChange(e,index){
		let inboxList = deepCopyObject(this.state.inboxList);
		inboxList[index][e.name]=e.value;
		this.setState({inboxList});
	}

	downloadMedia(item, type) {
		let self = this;
		let year = this.props.year;
		let documentUuid = null;
		let fisBil = null;
		if (self.state.selectedFisIndex !== null) {
			fisBil = self.state.fisBilList[self.state.selectedFisIndex];
		} else if (self.state.selectedFisIndex === null) {
			fisBil = self.state.fisBilList[0];
		}

		if (type === "FISBIL") {
			documentUuid = fisBil.documentUuid;
		} else {
			documentUuid = item.documentUuid;
		}

		let params;
		if(!this.state.url) {
			if (this.props.documentType === "fisOutbox") {
				params = {
					url: `/outbox/downloadMedia/html`,
					responseType: 'arraybuffer',
					method: "post",
					data: {
						documentUuid,
						year
					}
				};
			} else if (this.props.documentType === "fisInbox") {
				params = {
					url: `/inbox/downloadMedia/html`,
					responseType: 'arraybuffer',
					method: "post",
					data: {
						documentUuid,
						year
					}
				};
			}else if (this.props.documentType === "archiveAccountingReceipt") {
				params = {
					url: `/eArchive/downloadMedia/html`,
					responseType: 'arraybuffer',
					method: "post",
					data: {
						documentUuid,
						year
					}
				};
			}

			this.setState({loadingHtml: true});
			request(params)
				.then(function (response) {
					let blob = new Blob([response.data], {type: response.headers["content-type"]});
					let urlCreator = window.URL || window.webkitURL;
					let url = urlCreator.createObjectURL(blob);
					self.setState({url, loadingHtml: false});
				}).catch(function (error) {
				if (error.response === undefined) {
					showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
				} else {
					let enc = new TextDecoder("utf-8");
					showAxiosError({message: enc.decode(error.response.data)});
				}
				self.setState({mediaModal: false, loadingHtml: false});
			});
		} else {
			this.setMediaModalClose();
		}
	}

	confirm = async(index) =>{
		let self= this;
		this._source = axios.CancelToken.source();
		let inboxList = deepCopyObject(self.state.inboxList);
		if(index>=0 && index < inboxList.length){
			let inbox = inboxList[index];
			let result = isValidInboxLine(inbox.inboxLineList);
			let valid = result.valid;
			if (valid) {
				let params = {
					url: `/connector/writeInvoiceSql/` + this.props.documentType,
					method: 'post',
					cancelToken: self._source.token,
					data: deepCopyObject(inbox)
				};

				inbox.status = "processing";
				inboxList[index]=inbox;
				self.setState({confirmBtnDisabled:true,inboxList});
				try {
					const response = await request(params);
					if (response.data != null) {
						let queries = response.data;
						if (queries != null && queries.hasOwnProperty('WRITE_INVOICE')) {
							self.send(queries["WRITE_INVOICE"], "WRITE_INVOICE");
						}
						if (queries != null && queries.hasOwnProperty('WRITE_DESPATCH')) {
							self.send(queries["WRITE_DESPATCH"], "WRITE_DESPATCH");
						}
						if (queries != null && queries.hasOwnProperty("WRITE_SEND_INVOICE")) {
							self.send(queries["WRITE_SEND_INVOICE"], "WRITE_SEND_INVOICE");
						}
					}
				}catch (error){
					if (axios.isCancel(error)) {

					}else{
						inbox.status = "error";
						inboxList[index]= inbox;
						self.setState({inboxList,confirmBtnDisabled:false});
						showAxiosError(error);
					}
					return;
				}
			}else{
				self.setState({error:result.error,confirmBtnDisabled:false});
				Alert.error(result.errorMessage, {
					position: 'bottom-right',
					effect: 'stackslide',
					timeout: 3000
				});
			}
		}else{
			Alert.warning('Tüm dokümanlar gönderildi.', {
				position: 'bottom-right',
				effect: 'stackslide',
				timeout: 5000
			});
			return;
		}
	}

	writeInvoiceLineSql = async(inbox,row)=>{
		let self = this;
		let params = {
			url: `/connector/writeInvoiceLineSql/${this.props.documentType}/${row.documentId}/${row.referenceId}`,
			method: 'post',
			data: inbox
		};
		try{
			let {data} = await request(params);
			console.log('fatura kalem sql listesi',data)
			if(data!=null){
				data.forEach(invoiceLineSql=>{
					self.send(invoiceLineSql,"WRITE_INVOICE_LINE");
				})
			}
		}catch(error){
			let err = {response:{data:"Konnektör Bulunamadı"}}
			showAxiosError(err);
		}
	}

	getRandomColor(documentUuid) {
		let {randomColorList} =  this.state;
		if(randomColorList[documentUuid]){
			return randomColorList[documentUuid];
		}else{
			randomColorList[documentUuid] = 'hsla(' + 360 * Math.random() + ', 50%, 50%)';
			this.setState({randomColorList});
			return randomColorList[documentUuid];
		}
	}

	arrowRenderer(e) {
		let onMouseDown = e.onMouseDown;
		return React.createElement('span', {
			className: 'search',
			onMouseDown: onMouseDown
		});
	}

	createCari(option, index) {
		let {vknTckn,
			formattedName,
			referenceId,
			city,
			citySubdivision,
			country,
			phone,
			streetName,
			taxOffice
		} = this.state.inboxList[index];

		let cari = {
			vknTckn,
			formattedName,
			referenceId,
			city,
			citySubdivision,
			country,
			phone,
			streetName,
			taxOffice
		};
		this.setState({cari, cariModal: true, index});
	}

	onCariChange(data, index) {
		if(parseInt(data.value)==-1){
			this.createCari("", index)
		}
		let self= this;
		if (data.hasOwnProperty("cari")) {
			let inboxList = deepCopyObject(this.state.inboxList);
			let cari = data.cari;
			inboxList[index].vknTckn=cari.vknTckn;
			inboxList[index].formattedName=cari.formattedName;
			inboxList[index].cariReferenceId=cari.referenceId;
			inboxList[index].cariCode=cari.cariCode;
			inboxList[index].success=true;
			self.setState({inboxList});
		}
	}

	onCancel(){
		if(this._source)
			this._source.cancel();

		if(this.state.index > 0){
			this.props.toggleModal(false,true);
		}else{
			this.props.toggleModal(false,false);
		}
	}

	getStatusRender(status) {
		let className =(status === "processing" ? "spinner fa-spin" : (status==="success" ? "check" :(status==="error" ? "close":"pause")));
		let color= (status === "processing" ? "dark" : (status==="success" ? "green" :(status==="error" ? "red":"dark")));
		return (<i className={"fas fa-" + className} style={{color:color,paddingRight:"4px"}}></i>);
	}

	validateClass(id) {
		let {error} = this.state;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let {error} = this.state;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	setCari(cari) {
		let {index,inboxList} = this.state;
		inboxList[index].vknTckn=cari.vknTckn;
		inboxList[index].formattedName=cari.formattedName;
		inboxList[index].cariReferenceId=cari.referenceId;
		inboxList[index].cariCode=cari.cariCode;
		inboxList[index].city=cari.city;
		inboxList[index].citySubdivision=cari.citySubdivision;
		inboxList[index].country=cari.country;
		inboxList[index].phone=cari.phone;
		inboxList[index].streetName=cari.streetName;
		inboxList[index].taxOffice=cari.taxOffice;
		inboxList[index].success=true;
		this.setState({inboxList,cariModal:false});
	}

	setMediaModalClose() {
		this.setState({url: null, mediaModal: false});
	}

	onChangeYevmiye(fisNo, index) {
		let yevmiyeList = deepCopyObject(this.state.yevmiyeList);
		let fisBilList = deepCopyObject(this.state.fisBilList);

		let oldYevmiye = fisBilList.filter((f) => {
			return f.selected === true;
		})
		if (oldYevmiye.length > 0) {
			let oldIndex = fisBilList.indexOf(oldYevmiye[0])
			if (oldIndex !== -1) {
				fisBilList[oldIndex]["selected"] = false
			}
		}

		fisBilList[index]["selected"] = true

		let yevmiye = yevmiyeList.filter((f) => {
			return f.fisNo === fisNo;
		})
		this.setMediaModalClose();
		this.setState({selectedFisIndex: index, selectedYevmiye: yevmiye, fisBilList: fisBilList});
	}

	onChangeHesapKodu(selected, index) {
		let newYevmiye = deepCopyObject(this.state.selectedYevmiye);
		let yevmiyeList = deepCopyObject(this.state.yevmiyeList);
		let yevmiyeIndex = yevmiyeList.findIndex(f => {
			return f.evrakNo === newYevmiye[index].evrakNo && f.refNo2 === newYevmiye[index].refNo2;
		});

		if (yevmiyeIndex !== -1) {
			yevmiyeList[yevmiyeIndex]["gmKod"] = selected.value;
		}
		newYevmiye[index]["gmKod"] = selected.value;
		this.setState({selectedYevmiye: newYevmiye, yevmiyeList: yevmiyeList, hesapSearchIsManual: false})
	}

	setLine(inboxLineList){
		let {inboxList,selectedIndex} = this.state;
		inboxList[selectedIndex].inboxLineList = inboxLineList;
		inboxList[selectedIndex].lineStatus=true;
		this.setState({inboxList,lineModal:false,selectedIndex:null});
	}

	readCustomer = (key) =>{
		const {ws} = this.state;
		this.setState({cariLoading:true});
		if (key.length > 0) {
			let params = {
				url: `/connector/readCustomer`,
				method: "post",
				data: key
			};
			request(params)
				.then(response => {
					this.send(response.data.result,"READ_CUSTOMER")

				}).catch(function (error) {
				showAxiosError(error);
			});
		} else {
			this.setState({cariOptions:[]});
			return Promise.resolve({options: []});

		}
	}

	 onChangeGetErpHesapKodu(e, index) {
		this.setState({hesapPlaniLoading: true});
		let options = []
		let newSelected = deepCopyObject(this.state.selectedYevmiye);

		if (e !== undefined && e !== "" && e !== null) {

			let hesapPlani = deepCopyObject(this.state.erpHesapPlani);

			let newHesapPlani = this.state.erpHesapPlaniData.filter((f) => {
				const value = f.value.startsWith(e);

				const splitLabel = f.label.split("-");
				const trimSplitLabel = splitLabel.length > 1 ? splitLabel[1].trim() : f.label;
				const label = turkishToLower(trimSplitLabel).includes(turkishToLower(e));

				return value || label;
			})

			newSelected[index]["gmKod"] = e;
			this.setState({selectedYevmiye: newSelected, erpHesapPlani: newHesapPlani, hesapPlaniLoading: false});

			if (hesapPlani.length > 0) {
				options = hesapPlani.map(hesapKod => ({
					value: JSON.stringify(hesapKod),
					label: hesapKod.kod
				}))
				return options;
			} else {
				return  Promise.resolve({options: []});
			}
		} else {
			this.setState({hesapPlaniLoading: false});
			return  Promise.resolve({options: []});
		}
	}

	arrowRenderer(e) {
		let onMouseDown = e.onMouseDown;
		return React.createElement('span', {
			className: 'search',
			onMouseDown: onMouseDown
		});
	}

	checkNullGmKod(check) {
		if (check) {
			this.setState({nullGmKod: true});
		} else {
			this.setState({nullGmKod: false});
		}
	}

	onChangeStockAccounting() {
		if (this.state.isStockAccounting) {
			this.setState({isStockAccounting: false}, () => {this.getFisData(this.state.fisNo)});
		} else {
			this.setState({isStockAccounting: true}, () => {this.getFisData(this.state.fisNo)});

		}
	}

	closeGmKodModal() {
		this.setState({createGmkodModal: false})
	}

	async confirmFis() {
		let fisBilList = deepCopyObject(this.state.fisBilList);
		let yevmiyeList = deepCopyObject(this.state.yevmiyeList);
		let sendFisBilList = [];
		let fisParams;

		if (fisBilList.length > 0 && yevmiyeList.length > 0) {
			fisParams = {
				url: "/connector/getFisQueryList",
				method: "post",
				data: {
					yevmiyeList: yevmiyeList,
					fisBilList: fisBilList
				}
			}

			if (yevmiyeList.length > 0) {
				let list = yevmiyeList.filter(f => f.gmKod === null || f.gmKod === "");
				if (list.length > 0) {
					return Alert.error('Hesap planı boş olamaz.', {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000,
						html: false
					});
				}
			}

			await request(fisParams).then((response) => {
				if (response.data?.length > 0) {
					for (let i = 0; i < response.data.length; i++) {
						this.send(response.data[i], "SAVE_YEVMIYE", null)
					}
					fisBilList.map(f => {
						sendFisBilList.push(f.evrakNo);
					})
				}
			})
		}


		if (sendFisBilList.length > 0) {
			let params = {};
			let documentType = this.props.documentType;
			params = {
				url: "/connector/update-fis-state",
				method: "post",
				data: {
					documentIds: sendFisBilList,
					year: this.props.year,
					month: this.props.month,
					fisType: documentType === "fisInbox" ? FisType.fisInbox : documentType === "fisOutbox" ? FisType.fisOutbox : FisType.archiveAccountingReceipt,
					fisState : 2 //muhasebeleşti
				},
			};
			request(params).then((response) => {
				Alert.success("Fişler kaydedildi.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000
				});
			})
			this.props.toggleModal(false,false);
		} else {
			Alert.success("Fişler daha önceden kaydedilmiştir.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
			this.props.toggleModal(false,false);
		}

	}

	render() {
		return (
				<DefaultModal
					disabled={(this.props.documentType !== "fisOutbox" && this.props.documentType !== "fisInbox" && this.props.documentType !== "archiveAccountingReceipt") ? this.state.loading || this.state.confirmBtnDisabled || (this.state.inboxList && this.state.inboxList.length === 0) : null}
					isOpen={this.props.modal}
					size={(this.props.documentType === "fisOutbox" || this.props.documentType === "fisInbox" || this.props.documentType === "archiveAccountingReceipt") ? "xxl" : "xl"}
					title={(this.props.documentType !== "fisOutbox" && this.props.documentType !== "fisInbox" && this.props.documentType !== "archiveAccountingReceipt") ? this.props.title || "" : "ERP Fiş Aktarımı"}
					confirmBtnText="Gönder"
					cancelBtnText="Kapat"
					onConfirm={(this.props.documentType !== "fisOutbox" && this.props.documentType !== "fisInbox" && this.props.documentType !== "archiveAccountingReceipt") ? (e) => this.confirm(this.state.index) : (e) => this.confirmFis()}
					onCancel={this.onCancel}
				>
					<div className="row" style={{overflow:'auto', overflowY:'scroll', overflowX: 'hidden'}}>
						<div sm="12 " className="row col-sm-12" style={{marginLeft: '10px', paddingLeft: "5px"}}>
							{!this.state.loading &&
								<p className="text-success" style={{margin: '0px', padding: "0px"}}>* ERP'deki cari
									bilgisi ile eşleşti.&nbsp;&nbsp;</p>
							}
						</div>
						<div sm="12" className="row col-sm-12" style={{marginLeft: '10px', paddingLeft: "5px"}}>
							{(this.props.documentType === "fisOutbox" || this.props.documentType === "fisInbox" || this.props.documentType === "archiveAccountingReceipt") &&
								<input type={"checkbox"}
									   style={{marginRight: '2px'}}
									   checked={this.state.isStockAccounting}
									   onChange={this.onChangeStockAccounting}
								/>
							}
							{(this.props.documentType === "fisOutbox" || this.props.documentType === "fisInbox" || this.props.documentType === "archiveAccountingReceipt") &&
								<h9>  Stoklu Muhasebeleştirme.</h9>
							}
						</div>

						{this.props.documentType !== "fisOutbox" && this.props.documentType !== "fisInbox" && this.props.documentType !== "archiveAccountingReceipt" &&
							<div className="col-sm-12" style={{paddingBottom: '20px', maxHeight: '500px'}}>
								<table className="" style={{textAlign: 'center', paddingBottom: '200px'}}>
									<thead>
									<tr style={{backgroundColor: '#ebedf0'}}>
										<th width="5%">#</th>
										<th width="18%">Fatura No</th>
										<th width="18%">Fatura Tipi</th>
										<th width="20%">ERP Cari Kodu</th>
										<th width="15%">VKN/TCKN</th>
										<th width="36%">Unvan</th>
										<th width="6%">İşlemler</th>
									</tr>
									</thead>
									<tbody>
									{this.state.loading ?
										<tr>
											<td colSpan={15}>
												<ReactLoading type="spinningBubbles" style={{
													width: "70px",
													height: "70px",
													margin: "20px auto 0 auto",
													fill: "#888"
												}}/></td>
										</tr>
										:
											this.state.inboxList.map((inbox, index) =>
												<tr key={index}
													style={{backgroundColor: (inbox.success ? 'lightgreen' : '')}}>
													<td style={{margin: "0px"}}>{this.state.realIndex + (index + 1)}</td>
													<td style={{
														fontWeight: 'bold',
														fontSize: '12px',
														padding: "0px",
														margin: "0px",
														backgroundColor: "inherit",
														color: this.getRandomColor(this.state.inboxList[index].documentUuid)
													}}>{this.state.inboxList[index].documentId}</td>
													<td>
														<Select
															value={inbox.documentType ? inbox.documentType : (this.props.documentType === "invoiceOutbox" || "earchiveInvoice" === this.props.documentType) ? "SATISFATURASI" : "ALISFATURASI"}
															defaultValue={inbox.documentType !== "invoiceOutbox" || "earchiveInvoice" !== this.props.documentType ? {
																label: "ALIŞ FATURASI",
																value: "ALISFATURASI"
															} : {label: "SATIŞ FATURASI", value: "SATISFATURASI"}}
															clearable={false}
															id="documentType"
															name="documentType"
															placeholder="Seçiniz..."
															noResultsText="Kayıt bulunamadı."
															onChange={(e) => this.onChange({
																value: e.value,
																name: "documentType"
															}, index)}
															style={this.customStyle}
															options={
																(this.props.documentType !== "invoiceOutbox" && "earchiveInvoice" !== this.props.documentType) ? [
																		{
																			value: "ALISFATURASI",
																			label: "ALIŞ FATURASI",
																			style: {fontSize: '12px'}
																		},
																		{
																			value: "ALISHIZMETFATURASI",
																			label: "ALIŞ HİZMET FATURASI",
																			style: {fontSize: '12px'}
																		}]
																	: [
																		{
																			value: "SATISFATURASI",
																			label: "SATIŞ FATURASI",
																			style: {fontSize: '12px'}
																		}]}
														/>
													</td>
													<td className={"form-group" + this.validateClass('cariCode_' + index)}>
														{this.state.manual &&
															<input
																id={'cariCode_' + index}
																type="text"
																disabled={inbox.success}
																data-vlength="1,255"
																maxLength={255}
																className="form-control"
																value={inbox.cariCode}
																onChange={(e) => this.onChange({
																	value: e.target.value,
																	name: "cariCode"
																}, index)}/>
														}
														{!this.state.manual &&
															<Select.Creatable
																clearable={false}
																multi={false}
																className="select-control"
																// wrapperStyle={{position: 'relative', zIndex: 9999}}
																ignoreAccents={false}
																id={'cariCode_' + index}
																value={{
																	value: inbox.cariCode,
																	label: inbox.cariCode
																}}
																onChange={(e) => e && this.onCariChange(e, index)}
																onInputChange={(key) => this.readCustomer(key)}
																isLoading={this.state.cariLoading}
																autoload={false}
																cache={false}
																noResultsText="Kayıt bulunamadı."
																searchPromptText="Arama için en az 1 karakter giriniz."
																placeholder="Cari VKN/TCKN veya Kodu ile arama yapabilirsiniz"
																loadingPlaceholder="Yükleniyor..."
																filterOptions={(options, filter, currentValues) => filterOptions(options, filter, currentValues)}
																onNewOptionClick={(option) => this.createCari(option, index)}
																promptTextCreator={(label) => "ERP Cari Listesine Ekle"}
																showNewOptionAtTop={false}
																arrowRenderer={this.arrowRenderer}
																onCloseResetsInput={false}
																onSelectResetsInput={false}
																onBlurResetsInput={false}
																options={this.state.cariOptions}
																// loadOptions={}
															/>}
													</td>
													<td className={"form-group" + this.validateClass('vknTckn' + index)}>
														<input
															id={'vknTckn_' + index}
															type="text"
															data-vlength="1,255"
															maxLength={255}
															className="form-control"
															value={inbox.vknTckn}
															onChange={(e) => this.onChange({
																value: e.target.value,
																name: "vknTckn"
															}, index)}/>
														{this.validateMessage('vknTckn_' + index) !== "" &&
															<UncontrolledTooltip placement="right"
																				 target={'vknTckn_' + index}
																				 delay={0}>
																{this.validateMessage('vknTckn_' + index)}
															</UncontrolledTooltip>}
													</td>
													<td className={"form-group" + this.validateClass('formattedName_' + index)}>
														<input
															id={'formattedName_' + index}
															type="text"
															maxLength={255}
															className="form-control"
															value={inbox.formattedName}
															onChange={(e) => this.onChange({
																value: e.target.value,
																name: "formattedName"
															}, index)}/>
														{this.validateMessage('formattedName_' + index) !== "" &&
															<UncontrolledTooltip placement="right"
																				 target={'formattedName_' + index}
																				 delay={0}>
																{this.validateMessage('formattedName_' + index)}
															</UncontrolledTooltip>}
													</td>
													<td style={{margin: "0px", backgroundColor: ''}}>
														{!inbox.status ?
															<button type="button"
																	className="Btn edit"
																	style={{background: (inbox.lineStatus ? 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))' : 'linear-gradient(#ccc, #ccc)')}}
																	onClick={() => this.setState({
																		lineModal: true,
																		selectedIndex: index
																	})}
															>
															</button> : this.getStatusRender(inbox.status)
														}
													</td>
												</tr>
											)}
									</tbody>
								</table>
							</div>
						}
						{(this.props.documentType === "fisOutbox" || this.props.documentType === "fisInbox" || this.props.documentType === "archiveAccountingReceipt") &&
							<div className="col-sm-12" style={{maxHeight: '500px'}}>
								<p style={{fontWeight: "bold"}}>Fiş Bilgisi</p>
								<div style={{maxHeight: '250px', overflow: 'auto'}}>
									<table className="" style={{
										textAlign: 'center',
										paddingBottom: '50px'
									}}>
										<thead>
										<tr style={{backgroundColor: '#ebedf0'}}>
											<th width="5%">#</th>
											<th width="15%">Fiş Tarihi</th>
											<th width="8%">Fiş Numarası</th>
											<th width="15%">Evrak No</th>
											<th width="20%">Unvan</th>
											<th width="8%">Borç</th>
											<th width="8%">Alacak</th>
											<th width="8%">İşlemler</th>
										</tr>
										</thead>
										<tbody>
										{this.state.loading ?
											<tr>
												<td colSpan={15}>
													<ReactLoading type="spinningBubbles" style={{
														width: "70px",
														height: "70px",
														margin: "20px auto 0 auto",
														fill: "#888"
													}}/></td>
											</tr>
											:
											this.state.fisBilList.length > 0 && this.state.fisBilList.map((inbox, index) =>
												<tr key={index}
													style={{backgroundColor: (inbox.selected ? 'lightgreen' : '')}}>
													<td style={{margin: "0px"}}>
														<a type="button"
														   disabled={this.state.yevmiyeList[index] === undefined || this.state.yevmiyeList[index] === null}
														   onClick={() =>
															   this.onChangeYevmiye(inbox.fisNo, index)
														   }
														>{(index + 1)}</a>
													</td>
													<td className={"form-group"}>
														<a type="button"
														   disabled={this.state.yevmiyeList[index] === undefined || this.state.yevmiyeList[index] === null}
														   onClick={() =>
															   this.onChangeYevmiye(inbox.fisNo, index)
														   }
														>{moment(inbox.fisTar).format("DD/MM/YYYY")}</a>
													</td>
													<td style={{
														fontWeight: 'bold',
														fontSize: '12px',
														padding: "0px",
														margin: "0px",
														backgroundColor: "inherit"
													}}>{this.state.fisBilList[index].fisNo}</td>
													<td className={"form-group"}>
														<a type="button"
														   disabled={this.state.yevmiyeList[index] === undefined || this.state.yevmiyeList[index] === null}
														   onClick={() =>
															   this.onChangeYevmiye(inbox.fisNo, index)
														   }
														>{inbox.evrakNo}</a>
													</td>
													<td className={"form-group"}>
														<a type="button"
														   disabled={this.state.yevmiyeList[index] === undefined || this.state.yevmiyeList[index] === null}
														   onClick={() =>
															   this.onChangeYevmiye(inbox.fisNo, index)
														   }
														>{inbox.unvan}</a>
													</td>
													<td className={"form-group"}>
														<a type="button"
														   disabled={this.state.yevmiyeList[index] === undefined || this.state.yevmiyeList[index] === null}
														   onClick={() =>
															   this.onChangeYevmiye(inbox.fisNo, index)
														   }
														>{inbox.btop ? changeNumberFormat(inbox.btop) : null}</a>
													</td>
													<td>
														<a type="button"
														   disabled={this.state.yevmiyeList[index] === undefined || this.state.yevmiyeList[index] === null}
														   onClick={() =>
															   this.onChangeYevmiye(inbox.fisNo, index)
														   }
														>{inbox.atop ? changeNumberFormat(inbox.atop) : null}</a>
													</td>
													<td className={"form-group"}>
														<a style={{cursor: "pointer"}} onClick={() => {
															this.downloadMedia(inbox, "FISBIL")
														}}><i className="fa fa-eye"/>
														</a>
													</td>
												</tr>
											)
										}
										</tbody>
									</table>
								</div>
							</div>
						}
						{this.state.selectedYevmiye.length > 0 &&
							<div className="col-sm-12" style={{paddingBottom: '20px', maxHeight: '500px'}}>
								<p style={{fontWeight: "bold"}}>Fiş Bilgisi Detay</p>
								{this.state.nullGmKod &&
									<SweetAlert type="info"
												confirmBtnText="Tamam"
												confirmBtnBsStyle="danger"
												title={"HATA"}
												onConfirm={() => {
													this.setState({nullGmKod: false})
												}}>
										Hesap Kodlarını Kontrol Ediniz.
									</SweetAlert>
								}
								<table className="" style={{textAlign: 'center', paddingBottom: '50px'}}>
									<thead>
									<tr style={{backgroundColor: '#ebedf0'}}>
										<th width="5%">#</th>
										<th width="15%">Fiş Tarihi</th>
										<th width="8%">Fiş Numarası</th>
										<th width="15%">Evrak No</th>
										<th width="15%">Vergi No</th>
										<th width="15%">Hesap Kodu</th>
										<th width="8%">Borçlu</th>
										<th width="8%">Alacaklı</th>
									</tr>
									</thead>
									<tbody>
									{this.state.selectedYevmiye.map((inbox, index) =>
										<tr key={index} style={{backgroundColor: (inbox.success ? 'lightgreen' : '')}}>
											<td style={{margin: "0px"}}>{(index + 1)}</td>
											<td className={"form-group"}>
												{moment(inbox.fisTar).format("DD/MM/YYYY")}
											</td>
											<td style={{
												fontWeight: 'bold',
												fontSize: '12px',
												padding: "0px",
												margin: "0px",
												backgroundColor: "inherit"
											}}>{inbox.fisNo}</td>
											<td className={"form-group"}>
												{inbox.evrakNo}
											</td>
											<td className={"form-group"}>
												{inbox.vergiNo}
											</td>
											<td className={"form-group"}>
												{this.state.hesapSearchIsManual &&
													<input
														id={'gmKod_' + index}
														type="text"
														data-vlength="1,255"
														maxLength={255}
														className="form-control"
														value={inbox.gmKod}
														onChange={(e) => this.onChangeHesapKodu({
															value: e.target.value,
															name: "gmKod"
														}, index)}/>
												}
												{!this.state.hesapSearchIsManual &&
													<Select.Creatable
														clearable={false}
														multi={false}
														className="select-control"
														ignoreAccents={false}
														id={'gmKod_' + index}
														value={{
															value: inbox.gmKod,
															label: inbox.gmKod
														}}
														onChange={(e) => e && this.onChangeHesapKodu(e, index)}
														onInputChange={(key) => this.onChangeGetErpHesapKodu(key, index)}
														isLoading={this.state.hesapPlaniLoading}
														autoload={false}
														cache={false}
														noResultsText="Kayıt bulunamadı."
														searchPromptText="Arama için en az 1 karakter giriniz."
														placeholder="Hesap Kodu Seçiniz..."
														loadingPlaceholder="Yükleniyor..."
														onNewOptionClick={(option) => this.openGmkodModal(true, index)}
														promptTextCreator={(label) => "ERP Stoğuna Ekle"}
														showNewOptionAtTop={false}
														arrowRenderer={this.arrowRenderer}
														onCloseResetsInput={false}
														onSelectResetsInput={false}
														onBlurResetsInput={false}
														options={this.state.erpHesapPlani}
													/>
												}
											</td>
											<td className={"form-group"}>
												{inbox.borclu ? changeNumberFormat(inbox.borclu) : inbox.borcluDoviz ? changeNumberFormat(inbox.borcluDoviz) : null}
											</td>
											<td className={"form-group"}>
												{inbox.alacakli ? changeNumberFormat(inbox.alacakli) : inbox.alacakliDoviz ? changeNumberFormat(inbox.alacakliDoviz) : null}
											</td>
										</tr>
									)}
									</tbody>
								</table>
							</div>
						}
						{this.state.selectedYevmiye.length > 0 &&
							<div className="row col-sm-12">
								<div className="col-sm-2"/>
								<div className="col-sm-8" style={{marginTop: "20px", marginBottom: "2px", top: 0, left: 0, minHeight:'90px'}}>
									{(this.state.url && !this.state.loadingHtml) &&
										<iframe src={this.state.url}
												frameBorder="0"
												border="0"
												cellSpacing="0"
												style={{
													borderStyle:'none',
													width: "100%",
													height: "450px",
												}}/>
									}
									{(!this.state.url && this.state.loadingHtml) && <ReactLoadingTop style={{width: '90px', height: '90px'}}/>}
								</div>
								<div className="col-sm-2"/>
							</div>
						}

					</div>
					{this.state.lineModal &&
						<ERPLineModalWs
							modal={this.state.lineModal}
							documentType={this.props.documentType}
							documentUuid={this.state.inboxList[this.state.selectedIndex].documentUuid}
							year={this.props.year}
                            month={this.props.month}
							title={this.state.inboxList[this.state.selectedIndex].documentId + " numaralı fatura kalemleri"}
							inboxLineList={this.state.inboxList[this.state.selectedIndex].inboxLineList}
							listener={this.setLine}
							currentUser={this.props.currentUser}
							connectionInfo={this.props.connectionInfo}
							toggleModal={() => this.setState({lineModal: false})}
						/>
					}
					{this.state.cariModal &&
						<CariModalWs
							cari={this.state.cari}
							modal={this.state.cariModal}
							send={this.send}
							toggleModal={() => this.setState({cariModal: false})}
						/>
					}
					{this.state.createGmkodModal &&
						<CreateGmkodModal
							modal={this.state.createGmkodModal}
							listener={this.createGmkod}
							closeModal={this.closeGmKodModal}
						/>

					}
				</DefaultModal>
		);
	}
}

export default SendToConnectorModalWs;
